import React from 'react';
import { Card } from '@brokerbay/design-components';
import styled from 'styled-components';
import { Text } from 'components';
import { Color } from '@bb/elements-web-rebranding';

const PaymentCard: React.FC = () => (
  <StyledCard
    title="Payment"
    withContent={false} // Set to true when you add content
  >
    <StyledBody>
      <StyledSection>
        <StyledHeader>Billing</StyledHeader>
      </StyledSection>
      <StyledSection>
        <StyledHeader>Payment method</StyledHeader>
      </StyledSection>
    </StyledBody>
  </StyledCard>
);

export default PaymentCard;

const StyledCard = styled(Card)<{ withContent?: boolean }>`
  ${({ withContent }) =>
    withContent &&
    `.ant-card-body {
    padding: 1px 0px;
  }`}
`;

const StyledBody = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  radius: 8px;
`;

const StyledSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border: 1px solid ${Color.LIGHTER_GREY};
  border-radius: 4px;
  padding: 16px;
  align-items: center;
`;

const StyledHeader = styled(Text)`
  color: ${Color.PRIMARY_TEXT};
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 8px;
`;
